import React from 'react';

function About() {
  return (
    <section id="about">
      <h2>About</h2>
      <p>
        I am Håkon Asdøl, a dedicated web developer and enthusiastic cross-country skier. From an early age, I have had a deep fascination for technology, which led me to pursue studies in web development at NTNU Gjøvik. My passion lies in creating modern and user-friendly websites using the latest web technologies.
        <br /> <br /> My experiences as an athlete have taught me the value of focused effort and patience. I believe that this mindset can have a positive impact on my work as a web developer. I am accustomed to setting ambitious goals and working hard to achieve them. This mentality is reflected in my work, where I constantly seek innovative solutions and expand my skill set.
      </p>
    </section>
  );
}

export default About;
